import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { artistUser } from "../data/data";
import { AboutBio, AboutCanvasSection } from "./AboutBio";
import { ArtworkImage } from "./ArtworkImage";

export function About() {
  const { t } = useTranslation();

  const timeline = [
    { key: "age4" },
    { key: "canvases" },
    { key: "digital" },
    { key: "ai" },
    { key: "today" },
  ] as const;

  return (
    <main>
      <section className="section-container py-12 sm:py-16">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <div className="order-2 lg:order-1">
            <p className="text-sm font-medium uppercase tracking-[0.15em] text-accent">
              {t("about.eyebrow")}
            </p>
            <h1 className="mt-2 font-display text-4xl font-semibold text-canvas-950 sm:text-5xl">
              {t("common.artistName")}
            </h1>
            <div className="mt-6">
              <AboutBio />
            </div>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/gallery?tab=canvas" className="btn-primary !text-xs">
                {t("about.viewCanvas")}
              </Link>
              <Link to="/contact#commission" className="btn-secondary !text-xs">
                {t("about.getInTouch")}
              </Link>
              <Link to="/gallery" className="btn-secondary !text-xs">
                {t("about.viewFullGallery")}
              </Link>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="art-card overflow-hidden">
              <ArtworkImage
                src={artistUser.aboutImageURL}
                alt={t("common.artistName")}
                aspectClass="aspect-[3/4]"
              />
            </div>
          </div>
        </div>
      </section>

      <AboutCanvasSection />

      <section className="border-t border-canvas-200/60 bg-canvas-100/50 py-16 sm:py-20">
        <div className="section-container">
          <h2 className="text-center font-display text-3xl font-semibold text-canvas-950">
            {t("about.journeyTitle")}
          </h2>
          <div className="mx-auto mt-12 grid max-w-3xl gap-8">
            {timeline.map((item) => (
              <div
                key={item.key}
                className="flex gap-6 rounded-2xl bg-white p-6 shadow-sm ring-1 ring-canvas-200/60"
              >
                <div className="shrink-0">
                  <span className="inline-block rounded-full bg-accent/10 px-3 py-1 text-sm font-semibold text-accent">
                    {t(`about.timeline.${item.key}.year`)}
                  </span>
                </div>
                <div>
                  <h3 className="font-display text-xl font-medium text-canvas-950">
                    {t(`about.timeline.${item.key}.title`)}
                  </h3>
                  <p className="mt-1 text-sm text-canvas-600">
                    {t(`about.timeline.${item.key}.desc`)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
